import { useDesktopBreakpoint } from '@customink/project-service-react-components';

import { useFeatureFlagEnabled } from '@/hooks/FeatureFlags';
import { useHasSignificantVolumeDiscount } from '@/hooks/Pricing';
import { VOLUME_DISCOUNT_FLAG_NAME } from '@/utils/featureFlags';

export const useShowStrikethroughPrice = () => {
  const isDesktop = useDesktopBreakpoint();
  const isVolumeDiscountEnabled = useFeatureFlagEnabled(
    VOLUME_DISCOUNT_FLAG_NAME,
  );
  const hasSignificantVolumeDiscount = useHasSignificantVolumeDiscount();

  return isDesktop && isVolumeDiscountEnabled && hasSignificantVolumeDiscount;
};
